/* import __COLOCATED_TEMPLATE__ from './control-time-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);

export default class ControlTimeReportCardComponent extends Component
{
	@service store;
	@service csv;

	@tracked intermediateTimingPoint = null;

	@tracked controlMargin = 600;
	@tracked controlButtonDisabled = false;

	@action
	async timingPointChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.intermediateTimingPoint = null;
		}
		else
		{
			this.intermediateTimingPoint = await this.store.findRecord('IntermediateTimingPoint', browserEvent.target.value);
		}
	}

	@action
	async controlReport()
	{
		this.controlButtonDisabled = true;

		try
		{
			if(this.args.event == null || this.intermediateTimingPoint == null)
			{
				return;
			}

			const controlData = [[
				"Bib","Control Time","Start Time","Diff","Error"
			]];

			const entries = [...(await this.args.event.get('entries'))];
			const targetTimingPointId = this.intermediateTimingPoint.id;
			const marginMs = this.controlMargin * 1000;

			for(const entry of entries)
			{
				const sTR = await entry.get('StartTimingRecordId');
				const iTRs = [...(await entry.get('intermediateTimingRecords'))];

				for(const iTR of iTRs)
				{
					const iTP = await iTR.get('IntermediateTimingPointId');
					if(iTP.id != targetTimingPointId) continue;

					const impulse = await iTR.get('impulseId');
					const diff = sTR.assignedStartTime - impulse.time;
					let diffFormatted = dayjs.utc(Math.abs(diff)).format("HH:mm:ss.S");
					if(diff < 0)
					{
						diffFormatted = "-" + diffFormatted;
					}
					controlData.push([
						entry.bib,
						dayjs(impulse.time).format("HH:mm.ss.S"),
						dayjs(sTR.assignedStartTime).format("HH:mm.ss.S"),
						diffFormatted,
						diff > marginMs
					]);
				}
			}

			this.csv.export(controlData, {fileName:'controlReport.csv', withSeparator:false});
		}
		finally
		{
			this.controlButtonDisabled = false;
		}
	}
}